import React from "react";

import { Stack, SxProps, Typography } from "@mui/material";

import HelpTip from "@rui/HelpTip";
import { Row } from "@rui/Stack";

interface SettingsTitleProps {
  title: string;
  subtitle?: string;
  recommendation?: { value: string; description: string };
  tooltip?: string;
  sx?: SxProps;
  endIcon?: React.ReactNode;
}

const SettingsTitle = ({
  title,
  subtitle,
  recommendation,
  tooltip,
  endIcon,
  sx,
}: SettingsTitleProps) => {
  return (
    <Stack direction="column" justifyContent="center" sx={sx} spacing={0.5}>
      <Row variant="left" spacing={1}>
        <Typography
          variant="bodyPrimaryMed"
          sx={{ color: "shades.neutral.700" }}
        >
          {title}
        </Typography>
        {endIcon}
      </Row>
      <Row alignItems="center">
        <Typography
          variant="bodySecondaryReg"
          sx={{ color: "shades.neutral.500" }}
        >
          {subtitle}
        </Typography>
        {tooltip && <HelpTip content={tooltip} sx={{ ml: 1 }} />}
      </Row>
      {recommendation && (
        <Typography
          variant="labelReg"
          sx={{ color: "shades.neutral.500", pt: 0.5 }}
        >
          Recommendation:{" "}
          <span style={{ fontWeight: 500 }}>{recommendation.value}</span> -{" "}
          {recommendation.description}
        </Typography>
      )}
    </Stack>
  );
};

export default SettingsTitle;
